import router from './router'
import Vue from 'vue'
import Vuex  from 'vuex'
import App from './App'
import moment from 'moment'
import VueCompositionApi from '@vue/composition-api';
import ElementUI from 'element-ui';
import VueSuperSlide from 'vue-superslide';
import Pagination from 'vue-pagination-2';
import('element-ui/lib/theme-chalk/index.css');
import store from './store';
import ('./style/commom.scss');
import $ from 'jquery';
import { initQiyu, openQiyuChat } from '@/utils/qiyu.js'; // 七鱼客服
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(VueCompositionApi);
Vue.use(VueSuperSlide)
Vue.component('pagination', Pagination);
Vue.prototype.$moment = moment
Vue.prototype.$openQiyu = openQiyuChat; // 页面内统一打开七鱼
moment.locale('zh-cn');
router.beforeEach((to,from,next)=>{
   // 路由发生变化修改标题
	window.document.title = to.meta.title == undefined ? "一起飞国际机票网" : to.meta.title
	// if (to.meta.title) {
	//   document.title = to.meta.title
	// }
    console.log(to.path+'3333');
    store.state.routerName=to.name;
    next();
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 预加载七鱼 SDK（隐藏官方浮标，使用站内「旅游顾问」入口）
initQiyu({ hidden: 1 }).catch(function(err) {
	console.warn('七鱼预加载失败', err);
});
